export const SET_LOGGER = 'set logger';

/* istanbul ignore next */
export function setLogger(logger){
    return  {
        type : SET_LOGGER,
        logger : logger
    };
}


// WEBPACK FOOTER //
// ./src/actions/helpers.action.js